'use client';

import type { SqlEngine } from '@repo/api-gw-sdk';
import { useCallback } from 'react';

import { DeleteEntityDialog } from '@/components/lakehouse/deleteEntityDialog';
import { useDAL } from '@/contexts/useDAL';

interface DeleteSqlEngineDialogProps {
  engine: SqlEngine;
  workspaceId: string;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
}

export const DeleteSqlEngineDialog = ({
  engine,
  workspaceId,
  open,
  onClose,
  onDeleted,
}: DeleteSqlEngineDialogProps) => {
  const dal = useDAL();

  const handleDelete = useCallback(async () => {
    await dal.lakehouse.deleteSqlEngine(workspaceId, engine.id);
    onDeleted();
  }, [dal, workspaceId, engine.id, onDeleted]);

  return (
    <DeleteEntityDialog
      open={open}
      title='Delete SQL Engine'
      entityLabel='SQL engine'
      entityName={engine.name}
      onClose={onClose}
      onDelete={handleDelete}
      testIdPrefix='confirm-delete-sql-engine'
    />
  );
};
